<forge-list #searchTree navlist [ngStyle]="listStyles" [ngClass]="{'search-tree': isFirstLevel, 'provisional': isFirstLevel && isProvisional}" [role]="depth === 0 ? 'tree' : 'group'">
  @for (child of children; track trackByTreePath($index, child)) {
    <ng-template [isLeaf]="child" [isLeafElse]="branch" [isLeafIndex]="$index">
      <forge-list-item #nodeItem [selected]="isSelected(child)" (contextmenu)="onLeafContextMenu($event, child)"
        (mouseup)="onLeafMouseup($event, child)" (mousedown)="onLeafMouseDown($event)"
        role="treeitem" [ngClass]="getLeafNodeClasses(child)"
        class="search-tree--item search-tree--leaf">
        <button (click)="onLeafClicked($event, child)" (keyup)="onLeafClicked($event, child)" fxLayout="row" fxLayoutAlign="start center">
          <span class="menu-key max-width-{{depth}}">{{child.Key}}</span>
          @if (showTooltip(child)) {
            <forge-tooltip placement="bottom-left">{{child.Key}}</forge-tooltip>
          }
        </button>
      </forge-list-item>
    </ng-template>
  }
</forge-list>

<ng-template #branch let-node let-i="index">
  <forge-expansion-panel #topMenuItem [open]="isPanelExpandedInitial(node)" [attr.tree-path]="node.TreePath">
    <forge-list-item slot="header" [selected]="isSelected(node)" [ngClass]="getListItemClasses(node)"
      class="search-tree--item" role="treeitem" [attr.aria-expanded]="isTreeNodeExpanded(node)"
      (forge-list-item-select)="onTreeClick(node)">
      <button type="button" [id]="getAccessibleId(node, i)" fxLayout="row" fxLayoutAlign="start center">
        <span class="menu-key max-width-{{depth}}">{{node.Key}}</span>
        @if (showTooltip(node)) {
          <forge-tooltip placement="bottom-left">{{node.Key}}</forge-tooltip>
        }
      </button>
      <forge-open-icon slot="end" orientation="horizontal" rotation="half"></forge-open-icon>
    </forge-list-item>
    @if (isTreeNodeExpanded(node)) {
      <div>
        <tree [dataSource]="node" [depth]="depth + 1" [filter]="filter" [selected]="selected"
          (select)="onSelect($event)">
        </tree>
      </div>
    }
  </forge-expansion-panel>
</ng-template>
